// store a single article bookmark (persistent) - testing

var waypoint = document.body.scrollHeight / 2;
window.onscroll = function () {
  if (
    document.body.scrollTop > waypoint ||
    document.documentElement.scrollTop > waypoint
  ) {
    var articleElement = document.querySelector("[data-article]");
    if (articleElement) {
      if (articleElement.getAttribute("recent-saved") !== "true") {
        window.squiz.fn.ArticleStorage.updateArticle(
          articleElement,
          "data-article"
        );
      }
    }
  }
};

// testing
if (process.env.LOCALHOST) {
  var articleElements = document.querySelectorAll("[data-article]");

  if (articleElements.length) {
    articleElements.forEach((element) => {
      if (element.getAttribute("recent-saved") !== "true") {
        window.squiz.fn.ArticleStorage.updateArticle(element, "data-article");
      }
    });
  }
}
